export default __webpack_public_path__ + "success-icon.9b6785d6d87bbaae63ac4e6d1958b664.svg";